module.exports = __webpack_public_path__ + "img/product-3.cc87595d.jpg";